import * as React from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import { styled } from '@mui/material';

const StyledBottomNavigation = styled((props) => <BottomNavigation {...props} />)({
  display: 'flex',
  alignItems: 'center',
  height: '76px',
  minHeight: '76px',
  maxHeight: '76px',
  padding: '16px 8px',
  boxSizing: 'border-box',
  borderRadius: '110px',
  backgroundColor: 'rgba(16, 16, 16, 0.05)',
  backgroundImage: 'none',
  backdropFilter: 'blur(10px)',
  WebkitBackdropFilter: 'blur(10px)',
  boxShadow: '0 2px 12px rgba(16, 16, 16, 0.06)',
});

export default StyledBottomNavigation;
